// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import 'babel-polyfill'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/common.css'
import './assets/style/customElement.css'
import './assets/style/maintenance.css'
import commonJs from './common/common.js'
import commonThreeD from './common/commonThreeD.js'
import constant from './common/constant.js'
import commonViewJs from './common/commonView.js'
import commonBlendingJs from './common/commonBlending.js'
import commonDrawJs from './common/commonDraw.js'
import cv from './components/index.js'
import muCv from './components/muCvIndex.js'
import muCvOne from './components/muCvOneIndex.js'
import axios from 'axios'
Vue.prototype.$constant = constant
Vue.prototype.$commonJs = commonJs
Vue.prototype.$commonThreeD = commonThreeD
Vue.prototype.$commonViewJs = commonViewJs
Vue.prototype.$commonBlendingJs = commonBlendingJs
Vue.prototype.$draw = commonDrawJs
Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(VueI18n)
Vue.use(ElementUI)
Vue.use(cv)
Vue.use(muCv)
Vue.use(muCvOne)
const i18n = new VueI18n({
  locale: 'en',
  // this.$i18n.locale
  messages: {
    'zh': require('./assets/language/zh.json'),
    'en': require('./assets/language/en.json'),
    'ja': require('./assets/language/ja.json'),
    'de': require('./assets/language/de.json'),
    'fr': require('./assets/language/fr.json'),
    'it': require('./assets/language/it.json'),
    'es': require('./assets/language/es.json'),
    'pt-PT': require('./assets/language/pt-PT.json'),
    'ru': require('./assets/language/ru.json'),
    'nl': require('./assets/language/nl.json'),
    'da': require('./assets/language/da.json'),
    'fi': require('./assets/language/fi.json'),
    'no': require('./assets/language/no.json'),
    'sv': require('./assets/language/sv.json'),
    'cs': require('./assets/language/cs.json'),
    'hu': require('./assets/language/hu.json'),
    'pl': require('./assets/language/pl.json'),
    'sk': require('./assets/language/sk.json'),
    'bg': require('./assets/language/bg.json'),
    'et': require('./assets/language/et.json'),
    'lv': require('./assets/language/lv.json'),
    'lt': require('./assets/language/lt.json'),
    'ro': require('./assets/language/ro.json'),
    'el': require('./assets/language/el.json'),
    'tr': require('./assets/language/tr.json'),
    'sl': require('./assets/language/sl.json'),
    'hr': require('./assets/language/hr.json'),
    'sr': require('./assets/language/sr.json'),
    'ar': require('./assets/language/ar.json'),
    'he': require('./assets/language/he.json'),
    'zh-TW': require('./assets/language/zh-TW.json'),
    'ko': require('./assets/language/ko.json'),
    'ta': require('./assets/language/ta.json'),
    'vi': require('./assets/language/vi.json'),
    'bi': require('./assets/language/bi.json')

  }
})
router.beforeEach(async (to, from, next) => {
  if (commonJs.isIE() && sessionStorage.getItem('reload')) {
    sessionStorage.removeItem('reload')
    window.location.reload()
  } else {
    next()
  }
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
})
function getData (val) {
  return axios.get(`static/data/${val}.json`)
}
axios.all([getData('brightness'), getData('optionLensList'), getData('optionLensSpec'), getData('projectorLensSpec'), getData('projectorSpec'), getData('initConfig')]).then((result) => {
  Vue.prototype.Brightness = result[0].data
  Vue.prototype.OptionLensList = result[1].data
  Vue.prototype.OptionLensSpec = result[2].data
  Vue.prototype.ProjectorLensSpec = result[3].data
  Vue.prototype.InitConfig = result[5].data
  let pdata
  if (result[4].data[0].isMainPSConfig === 1) {
    pdata = result[4].data.filter((item) => {
      return item.Search
    })
  } else {
    pdata = result[4].data
  }
  pdata[0].categoliesBm = result[4].data[0].categoliesBm
  pdata[0].categoliesHtm = result[4].data[0].categoliesHtm
  pdata[0].isMainPSConfig = result[4].data[0].isMainPSConfig
  Vue.prototype.ProjectorSpec = pdata
  // eslint-disable-next-line no-new
  new Vue({
    el: '#app',
    i18n,
    router,
    store,
    components: { App },
    template: '<App/>'
  })
}).catch((error) => {
  console.log('getData error...' + error)
})



// WEBPACK FOOTER //
// ./src/main.js